import { LoginForm } from "@/features/auth/components/login-form";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/login")({
  component: LoginPage,
});

function LoginPage() {
  return (
    <div
      data-testid="auth-login-page"
      className="flex min-h-screen items-center justify-center p-4"
    >
      <LoginForm />
    </div>
  );
}
